import { FormCheckbox, FormInput } from 'src/shared/components/FormComponents'
import { Column, Row } from 'src/shared/components/Semantic/all'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'src/shared/components/ui/card'
import { UseFormReturn } from 'react-hook-form'
import { FormData } from '../types'

export const PrintDetails = ({
  methods,
}: {
  methods: UseFormReturn<FormData>
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Print Details</CardTitle>
      </CardHeader>
      <CardContent>
        <Column className="gap-4">
          <Row className="gap-2 items-center">
            <FormInput
              label="Print techniques"
              placeholder="Enter print techniques"
              name="print_codes"
              methods={methods}
              type="text"
              className="w-1/4"
            />

            <FormInput
              label="MOQ"
              placeholder="0"
              name="moq"
              methods={methods}
              type="text"
            />
          </Row>
        </Column>
      </CardContent>
    </Card>
  )
}
